import { useEvent } from "react-use";
import { create } from "zustand";

interface IFrameReadyState {
	isReady: boolean;
	setReady: (ready: boolean) => void;
}

const useIFrameReadyStore = create<IFrameReadyState>((set) => ({
	isReady: false,
	setReady: (ready: boolean) => set({ isReady: ready }),
}));

export const useIFrameReadyState = () => {
	const { isReady, setReady } = useIFrameReadyStore();

	useEvent("message", (event) => {
		if (event.data?.type === "iframeReady") {
			setReady(true);
		}
	});

	return { isReady, setReady };
};
